<template>
  <tr>
    <th>{{ event.name }}</th>
    <td>
      <input
        :id="`active_${event._id}`"
        type="checkbox"
        :class="{ 'checked': event.activeEvent}"
        class="styled-checkbox"
        @click="updateActiveState($event)"
      >
      <label :for="`active_${event._id}`"/>
    </td>
    <td>
      <div
        v-if="event.divisions_docs.length > 0"
      >
        <span
          v-for="(division, index) in event.divisions_docs"
          :key="division._id"
        >
          <a
            href="#"
            @click.prevent="editDivision(division)"
          >{{ division.name }}</a>
          <span v-if="index < event.divisions_docs.length - 1">&nbsp;|&nbsp;</span>
        </span>
      </div>
      <div
        v-else
      >
        <a
          href="#"
          class="button is-small is-link is-outlined"
          @click.prevent="addDivision"
        >
          <span><PlusCircle />&nbsp;Add</span>
        </a>
      </div>
    </td>
    <td>
      <p>{{ event.description }}</p>
    </td>
    <td>
      {{ formatDate(event.eventStartDate, 'MM/DD/YYYY') }} — {{ formatDate(event.eventEndDate, 'MM/DD/YYYY') }}
    </td>
    <td>
      <span v-if="event.registrationPeriod">
        {{ formatDate(event.registrationStartDate, 'MM/DD/YYYY') }} — {{ formatDate(event.registrationEndDate, 'MM/DD/YYYY') }}
      </span>
      <span v-else>
        <Close />&nbsp;No registration
      </span>
    </td>
    <td>
      <div class="dropdown is-hoverable is-right">
        <div class="dropdown-trigger">
          <button class="button is-light" aria-haspopup="true" aria-controls="dropdown-menu">
            <span>Actions</span>
            <span>&nbsp;<ChevronDown aria-hidden="true" /></span>
          </button>
        </div>
        <div class="dropdown-menu" id="dropdown-menu" role="menu">
          <div class="dropdown-content">
            <a
              href="#"
              class="dropdown-item"
              @click.prevent="editEvent"
            >
              <span><Pencil />&nbsp;Edit</span>
            </a>
            <a
              href="#"
              class="dropdown-item"
              @click.prevent="addDivision"
            >
              <span><PlusCircle />&nbsp;Manage Divisions</span>
            </a>
            <hr class="dropdown-divider">
            <a
              href="#"
              class="dropdown-item has-text-danger"
              @click.prevent="deleteEvent"
            >
              <span><Delete />&nbsp;Delete</span>
            </a>
          </div>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import Close from 'vue-material-design-icons/Close.vue'
import ChevronDown from 'vue-material-design-icons/ChevronDown.vue'
import Pencil from 'vue-material-design-icons/Pencil.vue'
import PlusCircle from 'vue-material-design-icons/PlusCircle.vue'
import Delete from 'vue-material-design-icons/Delete.vue'
import datesMixin from '@/mixins/dates'

export default {
  name: 'EventRow',
  mixins: [datesMixin],
  components: {
    Close,
    ChevronDown,
    Pencil,
    PlusCircle,
    Delete
  },
  props: {
    event: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      checkboxState: this.isActive
    }
  },
  methods: {
    updateActiveState (e) {
      let newState = e.target.checked
      this.$toasted.show(`Changing active event may break participant's experience.`, {
        duration: null,
        action: [
          {
            text: 'Cancel',
            onClick: (e, toastObject) => {
              this.checkboxState = !newState
              toastObject.goAway(0)
            }
          },
          {
            text: 'Ok',
            onClick: (e, toastObject) => {
              toastObject.goAway(0)
              this.dispatchUpdate({
                match: {
                  _id: this.event._id
                },
                update: {
                  activeEvent: newState
                }
              })
            }
          }
        ]
      })
    },
    editDivision (division) {
      this.$emit('editDivision', {
        _id: division._id,
        name: division.name,
        price: division.price,
        event: this.event._id
      })
    },
    editEvent () {
      this.$emit('editEvent', {
        _id: this.event._id,
        name: this.event.name,
        description: this.event.description,
        startDate: this.event.eventStartDate,
        endDate: this.event.eventEndDate,
        registrationPeriod: this.event.registrationPeriod,
        registrationStartDate: this.event.registrationStartDate,
        registrationEndDate: this.event.registrationEndDate
      })
    },
    deleteEvent () {
      this.$toasted.show(`Deleting an event will result in removing all related data (divisons, scores, etc).`, {
        duration: null,
        action: [
          {
            text: 'Cancel',
            onClick: (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
          {
            text: 'Ok',
            onClick: (e, toastObject) => {
              toastObject.goAway(0)
              this.dispatchDelete({
                match: {
                  _id: this.event._id
                }
              })
            }
          }
        ]
      })
    },
    addDivision () {
      this.$emit('addDivision', { _id: this.event._id })
    },
    //  API dispatching
    dispatchUpdate (data) {
      this.$store
        .dispatch('admin/UPDATE_EVENT', data)
        .then(() => {
          this.$toasted.success('Changed active event')
          this.$emit('updateEvents')
        })
        .catch(err => {
          this.$toasted.error('Error changing event')
          console.log(err)
        })
    },
    dispatchDelete (data) {
      this.$store
        .dispatch('admin/DELETE_EVENT', data)
        .then(() => {
          this.$toasted.success('Event deleted')
          this.$emit('updateEvents')
        })
        .catch(err => {
          this.$toasted.error('Error deleting event')
          console.log(err)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .actions{
    .button:nth-of-type(1){
      margin-right: 5px;
    }
  }
</style>
